import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TaskService} from '../../services/task.service';
import {DomSanitizer} from '@angular/platform-browser';
import {NzMessageService} from 'ng-zorro-antd/message';

@Component({
  selector: 'nf-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.css']
})
export class LinkComponent implements OnInit {

  boardId;
  boardData;
  pulses = [];
  @Input('nfBoardData') set ChangeBoardData(data: any) {
    if (data) {
      this.boardId = data.id;
      this.boardData = data.boardData;
      this.boardColumnData = data.boardData.columns || [];
      this.pulses = data.boardData.pulses || [];
      for (let column of this.boardColumnData) {
        if (column.type == 'text' || column.type == 'status' || column.type == 'dropdown' || column.type == 'select' || column.type == 'multiple-person') {
          this.selectOption.push(column);
        }
      }
    }
  };
  selectOption = [];
  @Input('boardColumn') set boardColumnChange(data) {
    if (data) {
      this.boardColumnData = data;
    }
  }
  boardColumnData = [];
  pulse: any = {};
  @Input('pulse') set pulseChange(data) {
    if (data) {
      this.pulse = data;
      if (this.boardColumnData) {
        for (let column of this.boardColumnData) {
          if (column.type == 'name') {
            this.taskName = this.pulse.columnValues[column.id];
            break;
          }
        }
      }
    }
  };
  taskName = '';
  @Input() columnValue = {
    name: '',
    url: '',
    params: [],
    skipMode: '1'
  };
  @Input() disabled = false;
  @Input() column: any = {};
  configPopVisible = false;
  modalVisible = false;
  modalWidth;
  modalHeight;
  pageUrl;
  @Output() updateFilterData: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private taskService: TaskService,
    private sanitizer: DomSanitizer,
    private message: NzMessageService
  ) { }

  ngOnInit(): void {
    this.modalWidth = window.innerWidth * 0.8;
    this.modalHeight = window.innerHeight * 0.85 + 'px';
  }

  addParam() {
    this.columnValue.params.push({
      code: '',
      column: null,
      value: ''
    });
  }

  removeParam(i) {
    this.columnValue.params.splice(i, 1);
  }

  saveValue(pulseIds) {
    const param = {};
    param['pulseIds'] = pulseIds;
    param['columnId'] = this.column.id;
    param['columnValue'] = this.columnValue;
    this.taskService.doEditPulse(this.boardId, param).subscribe((res: any) => {
      this.configPopVisible = false;
      this.updateFilterData.emit();
    });
  }

  cellSet() {
    this.saveValue([this.pulse.id]);
  }

  // 批量设置本组
  groupSet() {
    let pulseIds = [];
    for (let pulse of this.pulses) {
      if (pulse.groupId == this.pulse.groupId) {
        pulseIds.push(pulse.id);
        pulse.columnValues[this.column.id] = JSON.parse(JSON.stringify(this.columnValue));
      }
    }
    if (pulseIds.length > 0) {
      this.saveValue(pulseIds);
    }
  }

  // 批量清除本组
  groupClear() {
    this.columnValue = {
      name: '',
      url: '',
      params: [],
      skipMode: '1'
    };
    this.groupSet();
  }

  // 批量设置本列
  columnSet() {
    let pulseIds = [];
    for (let pulse of this.pulses) {
      pulseIds.push(pulse.id);
      pulse.columnValues[this.column.id] = JSON.parse(JSON.stringify(this.columnValue));
    }
    if (pulseIds.length > 0) {
      this.saveValue(pulseIds);
    }
  }

  // 批量清除本列
  columnClear() {
    this.columnValue = {
      name: '',
      url: '',
      params: [],
      skipMode: '1'
    };
    this.columnSet();
  }

  // 跳转到其他页面
  linkPage() {
    if (this.columnValue.url) {
      switch (this.columnValue.skipMode) {
        // 新页面打开
        case '1':
          this.pageJump(this.columnValue.url, '_blank');
          break;
        // 当前页面
        case '2':
          this.pageJump(this.columnValue.url, '_self');
          break;
        // 弹窗
        case '3':
          this.pageUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.generateParam(this.columnValue.url));
          this.modalVisible = true;
          break;
        default:
          this.pageJump(this.columnValue.url, '_blank');
      }
    }
  }

  pageJump(url, target) {
    url = this.generateParam(url);
    let newWin = window.open(url, target);
    if(!newWin){
      this.message.create('warning', '弹出窗口被拦截，请将浏览器设置为允许窗口弹出');
    }
  }

  generateParam(url: string): string {
    if (this.columnValue.params && this.columnValue.params.length > 0) {
      for (let param of this.columnValue.params) {
        this.handleColumn(param);
      }
      url = url + '?';
      for (let param of this.columnValue.params) {
        url += param.code + '=' + param.value + '&'
      }
      url = url.substring(0, url.length - 1);
    }
    return url;
  }

  handleColumn(param) {
    for (let column of this.boardColumnData) {
      if (column.id == param.column) {
        switch (column.type) {
          case 'text':
            param.value = this.pulse.columnValues[column.id];
            break;
          case 'status':
            let labels = column.labels;
            if (labels && labels.length > 0) {
              let columnValue = this.pulse.columnValues[column.id];
              if (columnValue) {
                let index = columnValue.index as number;
                param.value = labels[index].label;
              }
            }
            break;
          case 'dropdown':
            if (column.settings && column.settings.labels) {
              if (this.pulse.columnValues[column.id]) {
                let labels = column.settings.labels;
                let ids = this.pulse.columnValues[column.id].ids;
                let temp = '';
                for (let id of ids) {
                  for (let label of labels) {
                    if (id == label.id) {
                      temp += label.name + '&' + param.code + '=';
                      break;
                    }
                  }
                }
                temp = temp.substring(0, temp.lastIndexOf('&' + param.code + '='));
                param.value = temp;
              }
            }
            break;
          case 'select':
            if (column.config && column.config.option) {
              if (this.pulse.columnValues[column.id]) {
                let options = column.config.option;
                for (let option of options) {
                  if (option.id == this.pulse.columnValues[column.id].option) {
                    param.value = option.title;
                    break;
                  }
                }
              }
            }
            break;
          case 'multiple-person':
            let obj = this.pulse.columnValues[column.id];
            if (obj && obj.personsAndTeams && obj.personsAndTeams.length > 0) {
              let temp = '';
              for (let person of obj.personsAndTeams) {
                temp += person.id + '&' + param.code + '=';
              }
              temp = temp.substring(0, temp.lastIndexOf('&' + param.code + '='));
              param.value = temp;
            }
            break;
        }
      }
    }
  }
}
